import React, { useContext } from "react";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { Box } from "@material-ui/core";

export default function CustomLogo({ width }) {
  const {
    state: { appTheme },
  } = useContext(ConfigContext);

  return (
    <Box
      alt="Logo"
      style={{
        backgroundImage: `url(${appTheme.logoUrl})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: width,
        height: "100%",
        borderRadius: "0px",
      }}
    />
  );
}
